import { Admin, Resource, localStorageStore } from 'react-admin';
import {
  People as UsersIcon,
  AttachMoney as TransactionsIcon,
  BarChart as StatsIcon,
  Support as SupportIcon,
  AdminPanelSettings as AdminPanelSettingsIcon,
  Security as SecurityIcon,
  Settings as SettingsIcon,
  History as HistoryIcon,
  Event as EventIcon,
  Casino as BetsIcon,
  Chat as ChatIcon,
} from '@mui/icons-material';
import { authProvider } from './authProvider';
import { dataProvider } from './dataProvider';
import { darkTheme } from './theme';
import { i18nProvider } from './i18n';
import { Dashboard } from './pages/Dashboard';
import { Login } from './pages/Login';
import { UserStatsList } from './pages/statistics/UserStats';
import { OwnerStatsList } from './pages/statistics/OwnerStats';
import { UserList, UserShow, UserEdit } from './pages/users';
import { TransactionList, TransactionShow } from './pages/transactions';
import { TicketList, TicketShow } from './pages/support';
import { AdminUserList, AdminUserShow, AdminUserEdit, AdminUserCreate } from './pages/admin-users';
import { RoleList, RoleShow, RoleEdit, RoleCreate } from './pages/roles';
import { SettingsList } from './pages/settings';
import { AuditLogList, AuditLogShow } from './pages/audit';
import { EventList } from './pages/events/EventList';
import { EventShow } from './pages/events/EventShow';
import { BetList } from './pages/bets/BetList';
import { BetShow } from './pages/bets/BetShow';
import { ChatList } from './pages/chats/ChatList';
import { ChatShow } from './pages/chats/ChatShow';
import { ChatEdit } from './pages/chats/ChatEdit';

// Initialize store for react-admin v5
const store = localStorageStore();

function App() {
  return (
    <Admin
      authProvider={authProvider}
      dataProvider={dataProvider}
      i18nProvider={i18nProvider}
      store={store}
      dashboard={Dashboard}
      loginPage={Login}
      darkTheme={darkTheme}
      defaultTheme="dark"
      disableTelemetry
    >
      <Resource
        name="events"
        list={EventList}
        show={EventShow}
        icon={EventIcon}
        options={{ label: 'Events' }}
      />
      <Resource
        name="bets"
        list={BetList}
        show={BetShow}
        icon={BetsIcon}
        options={{ label: 'Bets' }}
      />
      <Resource
        name="chats"
        list={ChatList}
        show={ChatShow}
        edit={ChatEdit}
        icon={ChatIcon}
        options={{ label: 'Chats' }}
      />
      <Resource
        name="users"
        list={UserList}
        show={UserShow}
        edit={UserEdit}
        icon={UsersIcon}
        options={{ label: 'Users' }}
      />
      <Resource
        name="transactions"
        list={TransactionList}
        show={TransactionShow}
        icon={TransactionsIcon}
        options={{ label: 'Transactions' }}
      />
      <Resource
        name="statistics/users"
        list={UserStatsList}
        icon={StatsIcon}
        options={{ label: 'User Statistics' }}
      />
      <Resource
        name="statistics/owners"
        list={OwnerStatsList}
        icon={StatsIcon}
        options={{ label: 'Owner Statistics' }}
      />
      <Resource
        name="support/tickets"
        list={TicketList}
        show={TicketShow}
        icon={SupportIcon}
        options={{ label: 'Support Tickets' }}
      />
      <Resource
        name="admin-users"
        list={AdminUserList}
        show={AdminUserShow}
        edit={AdminUserEdit}
        create={AdminUserCreate}
        icon={AdminPanelSettingsIcon}
        options={{ label: 'Admin Users' }}
      />
      <Resource
        name="roles"
        list={RoleList}
        show={RoleShow}
        edit={RoleEdit}
        create={RoleCreate}
        icon={SecurityIcon}
        options={{ label: 'Roles' }}
      />
      <Resource
        name="settings"
        list={SettingsList}
        icon={SettingsIcon}
        options={{ label: 'Settings' }}
      />
      <Resource
        name="audit-log"
        list={AuditLogList}
        show={AuditLogShow}
        icon={HistoryIcon}
        options={{ label: 'Audit Log' }}
      />
    </Admin>
  );
}

export default App;
